import { marked } from 'marked'

// Configure marked options once
marked.setOptions({
  breaks: true, // Convert line breaks to <br>
  gfm: true,    // GitHub Flavored Markdown support
})

/**
 * Converts markdown text to HTML
 * @param markdown - The markdown string to convert
 * @returns HTML string with formatted content
 */
export function markdownToHtml(markdown: string): string {
  if (!markdown || typeof markdown !== 'string') {
    return ''
  }

  try {
    // Parse markdown to HTML
    // marked.parse() returns a string synchronously
    const html = marked.parse(markdown.trim())
    
    // Ensure we return a string
    let htmlString = ''
    if (typeof html === 'string') {
      htmlString = html
    } else if (html instanceof Promise) {
      // If it's a promise, we need to handle it (shouldn't happen in v17, but just in case)
      console.warn('marked.parse() returned a Promise, this is unexpected')
      return markdown // Return original if async
    } else {
      htmlString = String(html)
    }
    
    // Debug logging
    console.log('=== MARKDOWN CONVERSION ===')
    console.log('Input (first 200 chars):', markdown.substring(0, 200))
    console.log('Output HTML (first 300 chars):', htmlString.substring(0, 300))
    console.log('Full HTML length:', htmlString.length)
    
    return htmlString
  } catch (error) {
    console.error('Error parsing markdown:', error)
    // Fallback: return the original text if parsing fails
    return markdown
  }
}
